import { render, staticRenderFns } from "./DispatchersTotalsList.vue?vue&type=template&id=596db81d"
import script from "./DispatchersTotalsList.vue?vue&type=script&lang=js"
export * from "./DispatchersTotalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports